import { Stack, Typography } from "@mui/material";

export default function VariantCell({ variants }) {
  if (!variants || variants.length === 0) return "-";
  return (
    <Stack direction="row" spacing={0.5} alignItems="center">
      <Typography
        variant="body2"
        fontWeight={700}
        sx={{ color: "#000000DE", fontSize: "14px" }}
      >
        {variants?.value}
      </Typography>
    </Stack>
  );
}
